/* eslint-disable object-curly-newline */
/* eslint-disable react/prop-types */
/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable react/no-access-state-in-setstate */
/* eslint-disable jsx-a11y/no-noninteractive-element-interactions */
/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable dot-notation */
/* eslint-disable object-shorthand */
/* eslint-disable react/jsx-no-bind */
/* eslint-disable array-callback-return */
/* eslint-disable react/no-unused-state */
/* eslint-disable implicit-arrow-linebreak */
/* eslint-disable quotes */
/* eslint-disable quote-props */
/* eslint no-console: ["error", { allow: ["warn", "error"] }] */
import React, { Component } from 'react';

import { ToastsContainer, ToastsStore, ToastsContainerPosition } from 'react-toasts';
import TextField from '@material-ui/core/TextField';
import { debounce } from 'throttle-debounce';
import ReactTooltip from 'react-tooltip';
import axios from 'axios';
import ConfigurationScreenContentPlaylistItem from './ConfigurationScreenContentPlaylistItem/ConfigurationScreenContentPlaylistItem';
import ConfigurationScreenContentPlaylistUserItem from './ConfigurationScreenContentPlaylistUserItem/ConfigurationScreenContentPlaylistUserItem';
import PlaylistDropDownComponent from './PlaylistDropDownComponent';
import config from '../../../moramma-config.json';


import classes from './ConfigurationScreenContent.css';
import Aux from '../../../hoc/Aux';
import lang from '../../../lang.json';

class ConfigurationScreenContentPlaylist extends Component {
  state = {
    querySongs: [],
    playlistSongs: [],
    renderPlaylistSongs: [],
    showLoader: false,
    playlistList: [],
    selectedPlaylist: {
      name: ''
    },
    openModal: false,
    songModal: {},
    isProcessing: false,
    isProcessingQueryCache: [],
    userData: {},
    txtNewPlaylist: '',
    defaultPlaylist: {},
    menuChoose: '',
    txtPlaylistNameError: false
  }

  constructor() {
    super();
    this.callAjax = debounce(500, this.callAjax);
  }
 
  componentWillMount() {
    const localtoken = localStorage.getItem('API');
    console.warn('localtoken', localtoken);
    if (localtoken) {
      axios({
        method: 'post',
        url: `${config['BASE_API']}/react/user`,
        headers: {
          "Authorization": `Bearer ${localtoken}`,
          'Accept': 'application/json',
          'Content-Type': 'application/json',
        },
        data: { token: localtoken }
      }).then(items => {
        console.warn(items.data.data);
        const avialablePlaylists = [];
        if (items.data.data.playlists) {
          items.data.data.playlists.forEach(element => {
            avialablePlaylists.push(element);
          });
        }

        if (items.data.data.defaults) {
          if (items.data.data.defaults.defaultPlaylist) {
            this.setState({ defaultPlaylist: items.data.data.defaults.defaultPlaylist });
          }
        }
       
       
        this.setState({ playlistList: avialablePlaylists, userData: items.data.data });
      });
    }
  }

  printChange = (e) => {
    if (e.target.value === "" || !e.target.value) {
      this.setState({ querySongs: [], showLoader: false });
    } else {
      this.setState({ querySongs: [], showLoader: true });
      this.callAjax(e.target.value);
    }
  }

  callAjax = async (value) => {
    const localtoken = localStorage.getItem('API');
    if (localtoken) {
      axios({
        method: 'get',
        url: `${config['BASE_API']}/deezer/search/track?query="${value}"`,
        headers: {
          'Authorization': `Bearer ${localtoken}`,
          'Accept': 'application/json',
          'Content-Type': 'application/json',
        }
      }).then((songs) => {
        const songList = songs.data.data.slice(0, 50).map((song) => (
          <ConfigurationScreenContentPlaylistItem
            key={song.id}
            title={song.title}
            artist={song.artist.name}
            picture={song.album.cover}
            preview={song.preview}
            eventAddSong={this.addSong}
            eventPreviewSong={this.previewSong}
            eventPlayNowSong={this.playNowSong}
            eventOpenModal={this.onOpenModal}
            allSong={song}
          />
        ));
        this.setState({ querySongs: songList, showLoader: false });
      });
    }
  }

  onRemoveSong = (song) => {
    const localtoken = localStorage.getItem('API');
    
    axios({
      method: 'delete',
      url: `${config['BASE_API']}/react/playlist/song`,
      headers: {
        "Authorization": `Bearer ${localtoken}`,
        'Accept': 'application/json',
        'Content-Type': 'application/json',
      },
      data: {
        song: song,
        playlist: this.state.selectedPlaylist.name
      }
    }).then(items => {
      let index = -1;
      let counter = 0;
      items.data.data.playlists.forEach(el => {
        if (el.name === this.state.selectedPlaylist.name) {
          index = counter;
        }
        counter += 1;
      });

      const render = items.data.data.playlists[index].songs.map(songItem => {
        if (songItem.album) {
          return (
            <ConfigurationScreenContentPlaylistUserItem
              key={songItem.song.id}
              title={songItem.song.title}
              artist={songItem.song.artist.name}
              picture={songItem.song.album.cover}
              preview={songItem.song.preview}
              genres={songItem.album.genres.data}
              eventAddSong={this.addSong}
              eventPreviewSong={this.previewSong}
              eventPlayNowSong={this.playNowSong}
              eventRemoveSong={this.onRemoveSong}
              allSong={songItem.song}
            />
          );
        }
        return (
          <ConfigurationScreenContentPlaylistUserItem
            key={songItem.song.id}
            title={songItem.song.title}
            artist={songItem.song.artist.name}
            picture={songItem.song.album.cover_xl}
            preview={songItem.song.preview}
            // genres={songItem.album.genres.data} TOP HITS dont have genres
            eventAddSong={this.addSong}
            eventPreviewSong={this.previewSong}
            eventPlayNowSong={this.playNowSong}
            eventRemoveSong={this.onRemoveSong}
            allSong={songItem.song}
          />
        );
      });

      ToastsStore.success(`Removed!`);
      this.setState({ selectedPlaylist: items.data.data.playlists[index], renderPlaylistSongs: render, playlistSongs: items.data.data.playlists[index].songs });
    }).catch(err => {
      ToastsStore.warning('Ooops! An error occurred.');
      console.error('onRemoveSong', err);
    });  
  }

  addSong = (song) => {
    console.warn('name', this.state.selectedPlaylist.name);
    const localtoken = localStorage.getItem('API');
    if (!localtoken) {
      ToastsStore.warning(`no localtoken addSong`);
      return;
    }

    const tmpQuerySong = this.state.querySongs;
    this.setState({ isProcessing: true });
    const songsList = this.state.playlistSongs;
    
    console.warn('songli', songsList);

    if (songsList.some(item => (item.song.id === song.id))) {
      console.warn('esiste!');
      ToastsStore.warning(`${song.title} already exists!`);

      const render = songsList.map(songItem => {
        if (songItem.album) {
          return (
            <ConfigurationScreenContentPlaylistUserItem
              key={songItem.song.id}
              title={songItem.song.title}
              artist={songItem.song.artist.name}
              picture={songItem.song.album.cover}
              preview={songItem.song.preview}
              genres={songItem.album.genres.data}
              eventAddSong={this.addSong}
              eventPreviewSong={this.previewSong}
              eventPlayNowSong={this.playNowSong}
              eventRemoveSong={this.onRemoveSong}
              allSong={songItem.song}
            />
          );
        }
        return (
          <ConfigurationScreenContentPlaylistUserItem
            key={songItem.song.id}
            title={songItem.song.title}
            artist={songItem.song.artist.name}
            picture={songItem.song.album.cover_xl}
            preview={songItem.song.preview}
            // genres={songItem.album.genres.data} e.g. TOP HITS dont have genres
            eventAddSong={this.addSong}
            eventPreviewSong={this.previewSong}
            eventPlayNowSong={this.playNowSong}
            eventRemoveSong={this.onRemoveSong}
            allSong={songItem.song}
          />
        );
      });
      this.setState({
        renderPlaylistSongs: render, isProcessing: false, querySongs: tmpQuerySong, playlistSongs: songsList 
      });
      return;
    }

    console.warn(localtoken);
    axios({
      method: 'get',
      url: `${config['BASE_API']}/deezer/album/${song.album.id}`,
      headers: {
        'Authorization': `Bearer ${localtoken}`,
        'Accept': 'application/json',
        'Content-Type': 'application/json',
      }
    }).then((album) => {
      const newItem = {
        song: song,
        album: album.data.data
      };
    
      songsList.push(newItem);

      const render = songsList.map(songItem => {
        if (songItem.album) {
          return (
            <ConfigurationScreenContentPlaylistUserItem
              key={songItem.song.id}
              title={songItem.song.title}
              artist={songItem.song.artist.name}
              picture={songItem.song.album.cover}
              preview={songItem.song.preview}
              genres={songItem.album.genres.data}
              eventAddSong={this.addSong}
              eventPreviewSong={this.previewSong}
              eventPlayNowSong={this.playNowSong}
              eventRemoveSong={this.onRemoveSong}
              allSong={songItem.song}
            />
          );
        }
        return (
          <ConfigurationScreenContentPlaylistUserItem
            key={songItem.song.id}
            title={songItem.song.title}
            artist={songItem.song.artist.name}
            picture={songItem.song.album.cover_xl}
            preview={songItem.song.preview}
            // genres={songItem.album.genres.data} e.g. TOP HITS dont have genres
            eventAddSong={this.addSong}
            eventPreviewSong={this.previewSong}
            eventPlayNowSong={this.playNowSong}
            eventRemoveSong={this.onRemoveSong}
            allSong={songItem.song}
          />
        );
      });

      axios({
        method: 'put',
        url: `${config['BASE_API']}/react/playlist/song`,
        headers: {
          "Authorization": `Bearer ${localtoken}`,
          'Accept': 'application/json',
          'Content-Type': 'application/json',
        },
        data: {
          playlist: this.state.selectedPlaylist.name,
          song: newItem
        }
      }).then(() => {
        this.setState({
          renderPlaylistSongs: render, isProcessing: false, querySongs: tmpQuerySong, playlistSongs: songsList 
        });
        ToastsStore.success(`${song.title} added to playlist!`);
      }).catch(err => {
        this.setState({ isProcessing: false });
        console.error('erradd song api', err);
      });
    });
  }

  previewSong = (link) => {
    window.open(link, "_blank");
  }

  playNowSong = (song) => {
    const localtoken = localStorage.getItem('API');
    if (!localtoken) {
      // logger.error('[ManagerScreen|skipSong] Local token not found');
      this.logOut();
    }

    axios({
      method: 'put',
      url: `${config.BASE_API}/rooms/${this.state.userData.location.name}/songs/${song.id}/online`,
      headers: {
        Authorization: `Bearer ${localtoken}`,
        Accept: 'application/json',
        'Content-Type': 'application/json',
      },
      data: { token: localtoken, user: this.state.userData.location }
    }).then(() => {
      // logger.debug('[ManagerScreen|skipSong] song goes online');
      ToastsStore.success('done.');
    }).catch(err => {
      ToastsStore.warning('Error');
      console.error('[ManagerScreen|skipSong] error during API/rooms/x/songs/x/online', err);
    });
  }

  proposeAllSongs = () => {
    const songs = this.state.playlistSongs;
    const localtoken = localStorage.getItem('API');

    songs.forEach(itemSong => {
      axios({
        method: 'put',
        url: `${config['BASE_API']}/rooms/${this.state.userData.location.name}/songs/${itemSong.song.id}`,
        headers: {
          'Authorization': `Bearer ${localtoken}`,
          'Accept': 'application/json',
          'Content-Type': 'application/json',
        }
      }).then(() => {
        ToastsStore.success(`${itemSong.song.title} proposed.`);
      }).catch(err => {
        ToastsStore.error(`Unable to propose ${itemSong.song.title}. Check constraints.`);
        console.error('proposeAllSongs', err);
      });    
    });
  }

  dropdownEventSetDefaultPlaylistChange = (values) => {
    if (values[0]) {
      if (values[0].songs) {
        this.setState({ defaultPlaylist: values[0] });
      }
    }
  }

  dropDownEventChange = (values) => {
    if (values[0]) {
      if (values[0].songs) {
        const render = values[0].songs.map(songItem => {
          if (songItem.album) {
            return (
              <ConfigurationScreenContentPlaylistUserItem
                key={songItem.song.id}
                title={songItem.song.title}
                artist={songItem.song.artist.name}
                picture={songItem.song.album.cover}
                preview={songItem.song.preview}
                genres={songItem.album.genres.data}
                eventAddSong={this.addSong}
                eventPreviewSong={this.previewSong}
                eventPlayNowSong={this.playNowSong}
                eventRemoveSong={this.onRemoveSong}
                allSong={songItem.song}
              />
            );
          }
          return (
            <ConfigurationScreenContentPlaylistUserItem
              key={songItem.song.id}
              title={songItem.song.title}
              artist={songItem.song.artist.name}
              picture={songItem.song.album.cover_xl}
              preview={songItem.song.preview}
              // genres={songItem.album.genres.data} e.g. TOP HITS dont have genres
              eventAddSong={this.addSong}
              eventPreviewSong={this.previewSong}
              eventPlayNowSong={this.playNowSong}
              eventRemoveSong={this.onRemoveSong}
              allSong={songItem.song}
            />
          );
        });

        this.setState({ selectedPlaylist: values[0], renderPlaylistSongs: render, playlistSongs: values[0].songs });
      } 
    }
  }

  onOpenModal = (song) => {
    this.setState({ openModal: true, songModal: song });
  };
 
  onCloseModal = () => {
    this.setState({ openModal: false });
    this.setState({ openModal: false, songModal: {} });
  };

  deletePlaylist = () => {
    const localtoken = localStorage.getItem('API');
    axios({
      method: 'delete',
      url: `${config['BASE_API']}/react/playlist`,
      headers: {
        "Authorization": `Bearer ${localtoken}`,
        'Accept': 'application/json',
        'Content-Type': 'application/json',
      },
      data: { 
        playlist: this.state.selectedPlaylist.name
      }
    }).then(items => {
      const avialablePlaylists = [];
      if (items.data.data.playlists) {
        items.data.data.playlists.forEach(element => {
          avialablePlaylists.push(element);
        });
      }
      this.setState({ playlistList: avialablePlaylists, txtNewPlaylist: '' });
      window.location.reload();
      ToastsStore.success(`Done.`);
    }).catch(err => {
      ToastsStore.error(`An error occurred during server response. Retry.`);
      console.error('deletePlaylist', err);
    });
  }
  
  createNewPlaylist = () => {
    const localtoken = localStorage.getItem('API');
    if (this.state.txtNewPlaylist) {
      if (localtoken) {
        axios({
          method: 'put',
          url: `${config['BASE_API']}/react/playlist`,
          headers: {
            "Authorization": `Bearer ${localtoken}`,
            'Accept': 'application/json',
            'Content-Type': 'application/json',
          },
          data: {
            playlist: this.state.txtNewPlaylist 
          }
        }).then(items => {
          const avialablePlaylists = [];
          if (items.data.data.playlists) {
            items.data.data.playlists.forEach(element => {
              avialablePlaylists.push(element);
            });
          }
          this.setState({ playlistList: avialablePlaylists, txtNewPlaylist: '', selectedPlaylist: { name: '' }, menuChoose: 'editplaylist' });
          ToastsStore.success(`Done!`);
        }).catch(err => {
          console.error('createNewPlayliste', err);
          ToastsStore.error(`An error occurred during server response. Retry.`);
        });
      }
    } else {
      ToastsStore.error(`You need to insert a playlist name first!`);
    }
  }

  onChangeTxtNewPlaylist = (event) => {
    const regex = new RegExp(/^[a-zA-Z0-9_ ]{3,15}$/i);
    if (regex.test(event.target.value)) {
      this.setState({ txtNewPlaylist: event.target.value, txtPlaylistNameError: false });
    } else {
      this.setState({ txtNewPlaylist: event.target.value, txtPlaylistNameError: true });
    }
  }

  setNewDefaultPlaylist = () => {
    if (this.state.defaultPlaylist.songs.length < 25) {
      ToastsStore.warning(`Default playlist require min. 25 songs`);
      return;
    }

    const localtoken = localStorage.getItem('API');
    axios({
      method: 'put',
      url: `${config['BASE_API']}/react/playlist/default`,
      headers: {
        "Authorization": `Bearer ${localtoken}`,
        'Accept': 'application/json',
        'Content-Type': 'application/json',
      },
      data: {
        playlist: this.state.defaultPlaylist,
        room: this.state.userData.location.name 
      }
    }).then(items => {
      this.setState({ userData: items.data.data });
      ToastsStore.success(`Done!`);
    }).catch(err => {
      console.error('setNewDefaultPlaylist', err);
      ToastsStore.error(`An error occurred during server response. Retry.`);
    });
  }

  openDefPlaylistModal = () => {
    this.setState({ menuChoose: 'defplaylist' });
  }

  openBuildPlaylisttModal = () => {
    this.setState({ menuChoose: 'buildplaylist' });
  }

  openEditPlaylisttModal = () => {
    this.setState({ menuChoose: 'editplaylist' });
  }
  
  render() {
    return (
      <Aux>
        <div className="container-fluid">
          <div className="row">
            <div className="col" />
            <div className={`col-8 ${classes.TitleCard}`}> 
              <div className="row">
                <div className="col-8">
                  <br />
                  <h3> 
                    {lang[this.props.language].confscreen_playlist_title_1of2}
                    <br />
                    {lang[this.props.language].confscreen_playlist_title_2of2}
                  </h3>
                  <br />
                  <br />
                  <p className={classes.DescriptionCard}>
                    {lang[this.props.language].confscreen_playlist_description}
                  </p>
                  <br />
                </div>
                <div className="col-4 align-self-center">
                  <img src={require('../../../assets/img/playlist-img.png')} alt="img-psw" className={classes.ImgPlaylist} />
                </div>
              </div>
            </div>
            <div className="col" />
          </div>
          <br />
          <br />

          <div className="row">
            <div className="col-2" />
            <div className="col-8">
              <div className="row">
                <div className={`col-1 ${classes.LinkCard} ${classes.TxtCenter}`} onClick={this.openDefPlaylistModal}>
                  <img className={classes.ImgButtonLink} src={require('../../../assets/svg/ic-auto.svg')} alt="img" />
                  <p className={classes.DescriptionButton}>
                    <br />
                    {lang[this.props.language].confscreen_playlist_btn_default}
                  </p>
                </div>
                <div className={`col-1 ${classes.LinkCard} ${classes.TxtCenter}`} onClick={this.openBuildPlaylisttModal}>
                  <img className={classes.ImgButtonLink} src={require('../../../assets/svg/ic-add.svg')} alt="img" />
                  <p className={classes.DescriptionButton}>
                    <br />
                    {lang[this.props.language].confscreen_playlist_btn_create}
                  </p>
                </div>
                <div className={`col-1 ${classes.LinkCard} ${classes.TxtCenter}`} onClick={this.openEditPlaylisttModal}>
                  <img className={classes.ImgButtonLink} src={require('../../../assets/svg/ic-playlist.svg')} alt="img" />
                  <p className={classes.DescriptionButton}>
                    <br />
                    {lang[this.props.language].confscreen_playlist_btn_edit}
                  </p>
                </div>
              </div>
            </div>
          </div>

          {
            this.state.menuChoose === 'defplaylist' 
              ? (
                <div className="row">
                  <div className="col" />
                  <div className={`col-8 ${classes.DefCard}`}> 
                  
                    <div className="row">
                      <div className="col-12">
                        <br />
                        <h3> 
                          {lang[this.props.language].confscreen_playlist_default_title}
                          <i data-html="true" data-place="right" data-tip={lang[this.props.language].confscreen_playlist_default_hint} className={`fas fa-question-circle ${classes.HelpIcon} ${classes.TxtLeft}`} />
                        </h3>
                        <br />
                        <hr />
                        <p>
                          {lang[this.props.language].confscreen_playlist_default_actual}
                          :
                          <i>
                            {` ${this.state.userData.defaults.defaultPlaylist.name}`}
                          </i>
                          { 
                            <PlaylistDropDownComponent
                              options={this.state.playlistList}
                              title=""
                              eventChange={this.dropdownEventSetDefaultPlaylistChange}
                            /> 
                          }
                          <br />
                          <button className={`btn ${classes.ButtonGray} ${classes.TxtLeft}`} type="button" onClick={this.setNewDefaultPlaylist}>Imposta</button>
                        </p>
                      </div>
                    </div>
                  </div>
                  <div className="col" />
                  <ReactTooltip />
                </div>
                
              )
              : ''
          }

          {
            this.state.menuChoose === 'buildplaylist' 
              ? (
                <div className="row">
                  <div className="col" />
                  <div className={`col-8 ${classes.DefCard}`}> 
                  
                    <div className="row">
                      <div className="col-12">
                        <br />
                        <h3> 
                          {lang[this.props.language].confscreen_playlist_create_title}
                          <i data-html="true" data-place="right" data-tip={lang[this.props.language].confscreen_playlist_create_hint} className={`fas fa-question-circle ${classes.HelpIcon} ${classes.TxtLeft}`} />
                        </h3>
                        <br />
                        <hr />
                        <p>
                          <br />
                          <TextField
                            label={lang[this.props.language].confscreen_playlist_create_txt_name}
                            error={this.state.txtPlaylistNameError}
                            helperText={this.state.txtPlaylistNameError ? 'Must be > 3' : ''}
                            type="text"
                            name="name"
                            margin="dense"
                            variant="outlined"
                            className={classes.SearchBox}
                            onChange={this.onChangeTxtNewPlaylist}
                            value={this.state.txtNewPlaylist}
                          />
                          <br />
                          <button className={`btn ${classes.ButtonGray} ${classes.TxtLeft}`} type="button" onClick={this.createNewPlaylist}>Crea!</button>
                        </p>
                      </div>
                    </div>
                  </div>
                  <div className="col" />
                  <ReactTooltip />
                </div>
              )
              : ''
          }

          {
            this.state.menuChoose === 'editplaylist' 
              ? (
                <Aux>
                  <div className="row">
                    <div className="col" />
                    <div className={`col-8 ${classes.DefCard}`}>
                      <div className={`row ${classes.CardcontainerPadding}`}>
                        <div className="col">
                          <h4>
                            <span className={classes.Step}>
                              &nbsp;
                              1
                              <sup>°</sup>
                              &nbsp;
                            </span>
                            &nbsp;
                            {lang[this.props.language].confscreen_playlist_edit_title}
                            <i data-html="true" data-place="right" data-tip={lang[this.props.language].confscreen_playlist_edit_hint} className={`fas fa-question-circle ${classes.HelpIcon} ${classes.TxtLeft}`} />
                          </h4>
                          <hr />
                          <br />
                          <div>
                            { 
                              <PlaylistDropDownComponent
                                options={this.state.playlistList}
                                title={lang[this.props.language].confscreen_playlist_edit_choose_pl_first}
                                eventChange={this.dropDownEventChange}
                              /> 
                            }
                            <br />
                            {
                              this.state.selectedPlaylist.name === ''
                                ? (
                                  ''
                                )
                                : (
                                  <div>
                                    <p>
                                      {lang[this.props.language].confscreen_playlist_edit_txt_add_pl}
                                      :
                                    </p>
                                    <TextField
                                      error={this.state.txtNameError}
                                      helperText={this.state.txtNameError ? 'Almeno 3 caratteri..' : ''}
                                      label={lang[this.props.language].confscreen_playlist_edit_txt_search_song}
                                      type="text"
                                      name="name"
                                      autoComplete="autocompl"
                                      margin="normal"
                                      variant="outlined"
                                      onKeyUp={this.printChange.bind(this)}
                                      className={classes.SearchBox}
                                    />
                                  </div>
                                )
                            }
                            {
                              this.state.showLoader 
                                ? (
                                  <div className={classes.TxtCenter}>
                                    <img src="https://cdn.dribbble.com/users/911625/screenshots/4810094/singer.gif" className={classes.Loader} alt="loader" />
                                    <p><i>{lang[this.props.language].confscreen_playlist_edit_txt_searching}</i></p>        
                                  </div>  
                                )
                                : (
                                  ""
                                )
                            }
                            {
                              /* this.state.isProcessing 
                                ? (
                                  <div className={classes.TxtCenter}>
                                    <img src="https://i.pinimg.com/originals/ab/45/bb/ab45bb4451536652faca51ae4f42d5dd.gif" className={classes.LoaderProcessing} alt="loader" />
                                    <p><i>{lang[this.props.language].confscreen_playlist_edit_txt_adding}</i></p>        
                                  </div>  
                                )
                                : (
                                  ""
                                )  */
                            }
                            <br />
                            {
                              this.state.querySongs.length >= 1 ? (
                                <div className={classes.NestedScroll}>
                                  {
                                    this.state.isProcessing ? (
                                      <div className={classes.BlockingDiv}>
                                        {this.state.querySongs}
                                      </div>
                                    ) : (
                                      this.state.querySongs
                                    )
                                  }
                                </div>
                              ) : (
                                ''
                              )
                            }
                            
                          </div>
                        </div>
                      </div>
                    </div>
                    <div className="col" />
                  </div>
                  
                  <div className="col" />
                  <br />
                  <div className="row">
                    <div className="col" />
                    <div className={`col-8 ${classes.DefCard}`}>
                      <div className={`row ${classes.CardcontainerPadding}`}>
                        <div className="col">
                          <h4>
                            <span className={classes.Step}>
                              &nbsp;
                              2
                              <sup>°</sup>
                              &nbsp;
                            </span>
                            &nbsp;
                            {lang[this.props.language].confscreen_playlist_edit_playlist_title}
                            :
                            &nbsp;
                            {
                             
                              this.state.selectedPlaylist.name 
                                ? (
                                  this.state.selectedPlaylist.name 
                                ) : (
                                  <span>
                                    {lang[this.props.language].confscreen_playlist_edit_playlist_title_err}
                                    .
                                  </span>
                                )
                            }
                            <i data-html="true" data-place="right" data-tip={lang[this.props.language].confscreen_playlist_edit_playlist_hint} className={`fas fa-question-circle ${classes.HelpIcon} ${classes.TxtLeft}`} />
                          </h4>
                          {
                              this.state.selectedPlaylist.name 
                                ? (
                                  <div>
                                    <button type="button" className={`btn ${classes.ButtonGreen}`} onClick={this.proposeAllSongs}>{lang[this.props.language].confscreen_playlist_edit_playlist_btn_propose}</button> 
                                    <button type="button" className={`btn ${classes.ButtonRed}`} onClick={this.deletePlaylist}>{lang[this.props.language].confscreen_playlist_edit_playlist_btn_delete}</button>  
                                  </div>
                                ) : (
                                  <div />
                                )
                            }
                          <hr />
                          <br />
                          {
                            this.state.renderPlaylistSongs.length >= 1 ? (
                              <div className={classes.NestedScroll}>
                                {this.state.renderPlaylistSongs}
                              </div>
                            ) : (
                              ''
                            )
                          }
                          
                        </div>
                      </div>
                    </div>
                    <div className="col" />
                  </div>
                  <ReactTooltip />
                </Aux>
              )
              : ''
          }

          <br />
          <br />
        </div>
        <ToastsContainer store={ToastsStore} position={ToastsContainerPosition.TOP_RIGHT} />
        
      </Aux>
    );
  }
} 

export default ConfigurationScreenContentPlaylist;
